export class ClipboardHelper {
  static async copyText(text, onSuccess, onError) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        onSuccess();
      } catch {
        ClipboardHelper.manualCopyFallback(text, onSuccess, onError);
      }
    } else {
      ClipboardHelper.manualCopyFallback(text, onSuccess, onError);
    }
  }

  static manualCopyFallback(text, onSuccess, onError) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();

    try {
      if (document.execCommand('copy')) {
        onSuccess();
      } else {
        throw new Error('Falha ao copiar');
      }
    } catch {
      onError();
    } finally {
      document.body.removeChild(textArea);
    }
  }
}
